// Knowledge Library service — public + admin endpoints.

import { normalizeDigitsDeep } from "@/utils/normalizeDigits";

const RAW_BASE = process.env.REACT_APP_BACKEND_URL;
const useRelative =
  typeof window !== "undefined" &&
  (!RAW_BASE || window.location.origin === RAW_BASE.replace(/\/$/, ""));
const API = useRelative ? "/api" : `${(RAW_BASE || "").replace(/\/$/, "")}/api`;

const send = async (path, { method = "GET", body, signal } = {}) => {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: "include",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
    signal,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`${method} ${path} failed: ${res.status} ${text}`);
  }
  const ct = res.headers.get("content-type") || "";
  if (!ct.includes("application/json")) return null;
  return normalizeDigitsDeep(await res.json());
};

// Public
export const listKnowledge = (category, opts) =>
  send(`/knowledge${category ? `?category=${encodeURIComponent(category)}` : ""}`, opts);
export const getKnowledge  = (idOrSlug, opts) => send(`/knowledge/${idOrSlug}`, opts);

// Admin
export const adminListKnowledge   = (filters = {}) => {
  const q = new URLSearchParams();
  if (filters.category) q.set("category", filters.category);
  if (filters.status)   q.set("status",   filters.status);
  const suffix = q.toString() ? `?${q.toString()}` : "";
  return send(`/admin/knowledge${suffix}`);
};
export const adminGetKnowledge    = (idOrSlug) => send(`/admin/knowledge/${idOrSlug}`);
export const adminCreateKnowledge = (payload)  => send(`/admin/knowledge`, { method: "POST", body: payload });
export const adminUpdateKnowledge = (id, payload) => send(`/admin/knowledge/${id}`, { method: "PATCH", body: payload });
export const adminPublishKnowledge = (id) => send(`/admin/knowledge/${id}/publish`, { method: "POST" });
export const adminArchiveKnowledge = (id) => send(`/admin/knowledge/${id}/archive`, { method: "POST" });
export const adminToggleFeaturedKnowledge = (id) => send(`/admin/knowledge/${id}/toggle-featured`, { method: "POST" });
